import React from 'react';
import { motion } from 'framer-motion';
import { Ticket, Hotel, Plane, Car, ExternalLink, Tag } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function TicketsEvents() {
  const {
    t
  } = useLanguage();
  const deals = [{
    title: t('deals.tickets'),
    desc: t('deals.ticketsDesc'),
    icon: <Ticket className="text-portugal-gold" size={24} data-id="element-354" />,
    cta: t('deals.findTickets'),
    link: 'https://www.fifa.com/fifaplus/en/tournaments/mens/worldcup/canadamexicousa2026/tickets'
  }, {
    title: t('deals.hotels'),
    desc: t('deals.hotelsDesc'),
    icon: <Hotel className="text-portugal-gold" size={24} data-id="element-355" />,
    cta: t('deals.bookHotels'),
    link: 'https://www.booking.com'
  }, {
    title: t('deals.flights'),
    desc: t('deals.flightsDesc'),
    icon: <Plane className="text-portugal-gold" size={24} data-id="element-356" />,
    cta: t('deals.searchFlights'),
    link: 'https://www.google.com/travel/flights'
  }, {
    title: t('deals.transport'),
    desc: t('deals.transportDesc'),
    icon: <Car className="text-portugal-gold" size={24} data-id="element-357" />,
    cta: t('deals.planTransport'),
    link: 'https://www.rentalcars.com'
  }];
  return <section id="deals" className="py-12 md:py-24 bg-[#111] border-t border-white/5" data-id="element-358">
      <div className="container mx-auto px-6 md:px-12" data-id="element-359">
        {/* Section Header — consolidated */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-12" data-id="element-360">
          <h2 className="text-portugal-red font-oswald uppercase tracking-widest text-sm font-bold mb-3" data-id="element-361">
            {t('deals.label')}
          </h2>
          <h3 className="text-3xl md:text-5xl font-oswald font-bold uppercase mb-6" data-id="element-362">
            {t('deals.title1')}{' '}
            <span className="text-portugal-gold" data-id="element-363">{t('deals.title2')}</span>
          </h3>
          <p className="text-gray-400" data-id="element-364">{t('deals.desc')}</p>
        </motion.div>

        {/* Promo Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-portugal-dark-red to-portugal-red rounded-2xl p-6 md:p-8 mb-12 flex flex-col md:flex-row items-center justify-between gap-6 border border-portugal-gold/30 shadow-[0_0_30px_rgba(170,30,45,0.2)]" data-id="element-365">
          <div className="flex items-center gap-4" data-id="element-366">
            <div className="bg-portugal-gold text-portugal-black p-3 rounded-full" data-id="element-367">
              <Tag size={24} data-id="element-368" />
            </div>
            <div data-id="element-369">
              <h4 className="font-oswald text-xl md:text-2xl font-bold uppercase text-white" data-id="element-370">
                {t('deals.unlockVip')}
              </h4>
              <p className="text-white/80 text-sm" data-id="element-371">{t('deals.applyCode')}</p>
            </div>
          </div>
          <div className="bg-portugal-black/50 border border-portugal-gold/50 px-6 py-3 rounded-lg font-oswald text-2xl tracking-widest text-portugal-gold font-bold select-all" data-id="element-372">
            QTAP26
          </div>
        </motion.div>

        {/* Deals Grid — 2 columns on mobile */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-373">
          {deals.map((deal, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-[#0a0a0a] p-4 md:p-8 rounded-xl md:rounded-2xl border border-white/5 hover:border-portugal-gold transition-colors duration-300 flex flex-col h-full group" data-id="element-374">
              <div className="bg-white/5 w-10 h-10 md:w-14 md:h-14 rounded-lg md:rounded-xl flex items-center justify-center mb-3 md:mb-6 group-hover:bg-portugal-gold/10 transition-colors" data-id="element-375">
                {deal.icon}
              </div>
              <h4 className="font-oswald text-sm md:text-xl font-bold uppercase mb-1 md:mb-2 text-white leading-tight" data-id="element-376">
                {deal.title}
              </h4>
              <p className="text-[10px] md:text-sm text-gray-400 mb-4 md:mb-8 flex-grow leading-relaxed" data-id="element-377">
                {deal.desc}
              </p>
              <a href={deal.link} target="_blank" rel="noopener noreferrer" className="w-full bg-transparent border border-white/20 hover:border-portugal-gold hover:text-portugal-gold text-white px-3 md:px-6 py-2.5 md:py-3 rounded-lg md:rounded-xl font-oswald uppercase tracking-wider text-[10px] md:text-sm font-bold transition-all duration-300 flex items-center justify-center gap-1.5 md:gap-2 min-h-[44px]" data-id="element-378">
                {deal.cta} <ExternalLink size={12} className="md:w-4 md:h-4" data-id="element-379" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}